import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from './store';
import { impersonate, signOut } from './user';

interface HomeState {
  tinyAccountId: string | null;
}

export const initialState: HomeState = {
  tinyAccountId: null,
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setHomePageTinyAccountId(state, action: PayloadAction<string | null>) {
      state.tinyAccountId = action.payload;
    },
  },
  extraReducers: builder =>
    builder
      .addCase(signOut, (state, action) => {
        return initialState;
      })
      .addCase(impersonate, (state, action) => {
        return initialState;
      }),
});

// Selectors
const getHomeState = (state: RootState) => state.home;
export const getHomePageTinyAccountId = createSelector(
  getHomeState,
  state => state.tinyAccountId,
);

export const { setHomePageTinyAccountId } = homeSlice.actions;
export default homeSlice.reducer;
